// vant组件-按需导入组件
import Vue from 'vue'
import {
  Popup,
  Tabbar,
  TabbarItem,
  NavBar,
  Toast,
  GridItem,
  Search,
  Swipe,
  SwipeItem,
  Grid,
  Icon,
  Tag,
  Lazyload,
  Rate,
  ActionSheet,
  Dialog,
  Checkbox,
  Tab,
  Tabs,
  Field,
  CellGroup,
  Cell,
  Button,
  Loading,
  Progress,
  CollapseItem,
  Collapse,
  Sticky,
  Popover,
  Area,
  Picker,
  PullRefresh,
  List,
  Divider,
  Empty,
  DropdownMenu,
  DropdownItem,
  PasswordInput,
  NumberKeyboard,
  NoticeBar,
  Overlay,
  Stepper
} from 'vant'
import { Image as VanImage } from 'vant'
Vue.use(Stepper)
Vue.use(Overlay)
Vue.use(PasswordInput)
Vue.use(NumberKeyboard)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Empty)
Vue.use(Divider)
Vue.use(List)
Vue.use(PullRefresh)
Vue.use(Picker)
Vue.use(Area)
Vue.use(Popover)
Vue.use(Sticky)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Progress)
Vue.use(Loading)
Vue.use(VanImage)
Vue.use(Button)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Field)
Vue.use(NavBar)
Vue.use(Tabbar)
Vue.use(TabbarItem)
Vue.use(Toast)
Vue.use(GridItem)
Vue.use(Search)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Grid)
Vue.use(Icon)
Vue.use(Tag)
Vue.use(Lazyload)
Vue.use(Rate)
Vue.use(ActionSheet)
Vue.use(Dialog)
Vue.use(Checkbox)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Popup)
Vue.use(NoticeBar)
